import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay,debounceTime } from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';
import  dataurl from '../../assets/config.json';


  declare function Getapiurl():any;

@Injectable({
  providedIn: 'root'
})
export class CirculationService {
  callurl: string = '';
    pdfurl:string='';
  
clcd:string;
aycd:string;
usid:string;

constructor(private http: HttpClient,private _global: AppGlobals) {

    this.clcd=localStorage.getItem('clcd');
       this.aycd=localStorage.getItem('aycd');
       this.usid=localStorage.getItem('usid');
     
       this.callurl=_global.baseAPIUrl;
       this.pdfurl=_global.pdfurl;
  }

  
  getipurl(): any {
    debugger
   //let clcd=localStorage.getItem('clcd');
   const headers = new HttpHeaders();
   headers.append('Content-Type', 'application/json')
       
       headers .append('Access-Control-Allow-Methods', 'GET')
       headers.append('Access-Control-Allow-Origin', '*'); 
       headers.append('Access-Control-Allow-Headers', 'X-Requested-With,content-type');
   return this.http.get('http://mycampuz.co.in/ipwithport.php',{responseType:'text', headers:headers})
   .pipe(map((data: any) => {
           console.log('retres',JSON.stringify(data));
           this.callurl= data+'/mycampz/v3/';
       }));
 }

 getdatetoday()
 {
  let d: Date = new Date();
  var mnth;
  var day='';
  //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
  if(d.getMonth()>=10)
  {
    mnth=d.getMonth()+1;
  }
  else{
   // mnth='0'+d.getMonth()+1;
   mnth=d.getMonth()+1;
   mnth='0'+mnth;
  }

  if(d.getDate()>=10)
  {
    day=d.getDate().toString();
  }
  else{
    day='0'+d.getDate();
  }
  let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
    
return todayDate;

 }

 getsysdatetoday()
 {
  return this.http.get(this.callurl + 'getsysdate')
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));

 }

 getmontfirstdate()
 {
  return this.http.get(this.callurl + 'getfirstdate')
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));

 }

 getmontlastdate()
 {
  return this.http.get(this.callurl + 'getlastdate')
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
      }));

 }

 getlibmemberdetails(oprtype,sertxt,clid,crid): Observable<any> {
  // debugger
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    //let cldb=localStorage.getItem('cldb');
    
   let postdat={clcd:this.clcd,aycd:this.aycd,oprtype:oprtype,sertxt:sertxt,clid:clid,crsid:crid,status:''};
   return this.http.post(this.callurl + 'libcirmembers', postdat)
  // return this.http.get(this.callurl + 'libmembers/0/0/'+cldb+'/'+clcd+'/'+aycd+'/0')
   .pipe(map((data: any) => {
           console.log('retres', data);
           return data.libmembers;
       }));
}


getissueddetails(stuid: any,oprtype:any): Observable<any> {
 
  let postdat={stuid:stuid,clcd:this.clcd,aycd:this.aycd,oprtype:oprtype}
  return this.http.post( this.callurl + 'getallbookcirculated', postdat)
      .pipe(map((data: any) => {
          console.log('retres', data);
          return data.bookdetails;
      }));

}

checkbooklimit(bookid: any,stuid,memtype): Observable<any> {
                        
  debugger
  // let clcd=localStorage.getItem('clcd');
  //         let aycd=localStorage.getItem('aycd');
   var admdata={bookid:bookid,stuid:stuid,clcd:this.clcd,aycd:this.aycd,memtype:memtype};
  return this.http.post(this.callurl + 'checkbookcirlimit', admdata)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}


bulkbookcirculate(bookid: any): Observable<any> {
                        
  debugger
  bookid.usid=this.usid;
  // let clcd=localStorage.getItem('clcd');
  //         let aycd=localStorage.getItem('aycd');
  // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
  return this.http.post(this.callurl + 'bulkbookcirculation', bookid)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}



issuebook(bookid: any): Observable<any> {
                        
  debugger
  bookid.usid=this.usid;
  // let clcd=localStorage.getItem('clcd');
  //         let aycd=localStorage.getItem('aycd');
  // var admdata={bookid:bookid,stuid:stuid,clcd:clcd,aycd:aycd}
  return this.http.post(this.callurl + 'boobcirculate', bookid)
      .pipe(map((data: any) => {
          console.log('retres', 'response');
          return data
      }));
}

}
